'use client';

import { useEffect, useRef, useState } from 'react';

const WORDS = ['pathfinder.', 'security.', 'quality.'];
const PREFIX = '/code ';

export default function TypedHeader() {
  const [display, setDisplay] = useState(`${PREFIX}${WORDS[0]}`);
  const stateRef = useRef({
    text: `${PREFIX}${WORDS[0]}`,
    isDeleting: false,
    wordIndex: 0,
    pauseUntil: Date.now() + 2000,
  });

  useEffect(() => {
    let animId: number;

    const tick = () => {
      const s = stateRef.current;
      const now = Date.now();

      if (now < s.pauseUntil) {
        animId = requestAnimationFrame(tick);
        return;
      }

      const fullText = `${PREFIX}${WORDS[s.wordIndex % WORDS.length]}`;

      if (!s.isDeleting) {
        if (s.text.length < fullText.length) {
          s.text = fullText.substring(0, s.text.length + 1);
          setDisplay(s.text);
          setTimeout(() => { animId = requestAnimationFrame(tick); }, 120);
          return;
        }
        s.isDeleting = true;
        s.pauseUntil = now + 2000;
        animId = requestAnimationFrame(tick);
        return;
      }

      if (s.text.length > PREFIX.length) {
        s.text = s.text.substring(0, s.text.length - 1);
        setDisplay(s.text);
        setTimeout(() => { animId = requestAnimationFrame(tick); }, 60);
        return;
      }

      s.isDeleting = false;
      s.wordIndex++;
      animId = requestAnimationFrame(tick);
    };

    animId = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(animId);
    };
  }, []);

  const slash = display[0];
  const rest = display.slice(1);
  const endsWithDot = rest.endsWith('.');
  const body = endsWithDot ? rest.slice(0, -1) : rest;

  return (
    <span
      className="inline-block text-xl font-extrabold"
      style={{ minWidth: '190px', letterSpacing: '-0.025em', color: 'var(--ink-900)' }}
    >
      <span style={{ color: '#9de500' }}>{slash}</span>
      {body}
      {endsWithDot && <span style={{ color: '#9de500' }}>.</span>}
      <span className="animate-pulse text-gray-400">|</span>
    </span>
  );
}
